<template>
  <div class="antialiased">

    <Sidebar/>


    <div class="page">

      <Header @change="_search" hint="Ketik nama tim"/>

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">
                  Tim
                </h2>
              </div>

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto p-0">

                    <div class="input-icon">
                      <span class="input-icon-addon"> <i class="fe fe-align-left"></i> </span>
                      <select class="form-control" v-model="paginate.perPage" @change="paginate.currentPage = 1; _get()" :disabled="loading">
                        <option :value="num" v-for="(num, i) in [10,50,100,999]" :key="i" v-html="num == 999 ? 'Semua' : num"/>
                      </select>
                    </div>

                  </div>

                  <div class="col-auto btn-group">
                    <button
                      class="btn btn-outline-primary"
                      @click="_export"
                      :disabled="isExportRequest" 
                      v-html="isExportRequest ? spin() : 'Export'"
                    ></button>
                    <button 
                      class="btn btn-primary" 
                      @click="_add">Tambah</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>

          <Nodata v-if="!loading && data.length == 0"/>

          <div class="box" v-if="!loading && data.length > 0">
              <div class="card">
                <div class="table-respon sive">
                  <table class="table table-vcenter table-hover card-table table-striped">

                    <thead>
                      <tr class="text-muted">
                        <th>No</th>
                        <th>Perusahaan</th>
                        <th>Nama</th>
                        <th>Supervisor</th>
                        <th>Koordinator</th>
                        <th>Tipe</th>
                        <th>Nama Depo</th>
                        <th>Min. Order SKU</th>
                        <th>Min. Order Value</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, i) in filter" :key="i" >
                        <td>{{paginate.fromPage + i}}</td>
                        <td>
                          <span class="badge bg-blue-lt mr-2">{{row.kode_perusahaan}}</span>
                        </td>
                        <td>{{row.nama_tim}}</td>
                        <td>{{row.nama_supervisor}}</td>
                        <td>{{row.nama_koordinator}}</td>
                        <td>{{row.tipe}}</td>
                        <td>{{row.nama_depo}}</td>
                        <td>{{row.min_order_sku}}</td>
                        <td>{{ribuan(row.min_order_value)}}</td>
                        <td>
                          <span v-html="statusMapping[row.status]" class="badge w-100" :class="statusClass[row.status]" />
                        </td>
                        <td class="p-0">
                          <div class="btn-group">
                            <button class="btn btn-white btn-sm" @click="_edit(row)" v-html="ic('edit')"></button>
                            <button class="btn btn-white btn-sm text-danger" @click="_delete(row.id)" v-html="ic('trash')"></button>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>
          </div>

          <div class="container-fluid mt-2" v-if="data.length > 0 && !loading">
            <div class="row justify-content-center">
              <div class="col-12 col-md-auto text-center">
                <button class="btn btn-outline-primary mr-3" @click="_pagePrev">Prev</button>
                <button class="btn btn-outline-primary" @click="_pageNext">Next</button>
              </div>
            </div>
          </div>

          <!-- <b-pagination v-if="data.length > 0 && !loading" align="center" class="mt-5" :total-rows="paginate.totalRows" v-model="paginate.currentPage" :per-page="paginate.perPage" @change="_pageChange" /> -->

        </div>
      </div>

    </div>

    <FormTim
      :config.sync="form.config"
      :initData="form.data" :dismiss.sync="form.dismiss"
      :isSubmit.sync="form.isSubmit"
      @submit="form.action"
    />

    <Confirm :id.sync="confirm.id" :title.sync="confirm.title" :isSubmit.sync="confirm.isSubmit" @submit="confirm.action"/>

  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormTim from "./modals/form-tim.vue";

export default {
  name: "Tim",
  components: { FormTim },

  data() {
    return {
        auth: {},

        form: {
          config: { view: false, title: null },
          data: null, isSubmit: false,
          action: () => {}
        },

        confirm: {
          id: null, title: null, isSubmit: false, action: () => {}
        },

        loading: true,
        data: [], filter: [],

        paginate: {
          currentPage: 1,
          totalRows: 0,
          perPage: 10,
          fromPage: 0
        },

        dataFilter: {
          keyword: ''
        },

        statusClass: {
          active: "bg-green",
          non_active: "bg-danger",
        },

        statusMapping: {
          active: 'Active',
          non_active: 'Non Active'
        },

        isExportRequest: false,
    };
  },

  mixins: [helper],

  methods: {

      _get(params){
        this.loading = params == null ? true : !params.silent

        this.axios.get('tim?per_page='+this.paginate.perPage+'&page='+this.paginate.currentPage+'&keyword='+this.dataFilter.keyword).then(res => {
          this.loading = false;

          this.paginate.totalRows = res.data.meta.total;
          this.paginate.fromPage = res.data.meta.from
          this.paginate.to = res.data.meta.to;
          this.data = this.filter = res.data.data;
        }).catch( err => {
          this.loading = false
          this.onError(err)
        });
      },

      _add(data){
        this.form.config = {view: true, title: 'Tambah Tim'}
        this.form.data = null
        this.form.action = (formData) => {

          this.axios.post("tim", formData).then(() => {

            this._get({silent: true})

            this.toast('Berhasil ditambahkan');
            this.form.config.view = false;
          }).catch( err => {
            this.onError(err);
            this.form.isSubmit = false;
          });
        }
      },

      _edit(data){
        this.form.config = {view: true, title: 'Edit Tim'}
        this.form.data = data
        this.form.action = (formData) => {

          this.axios.put("tim/"+data.id, formData).then(() => {
            this._get({silent: true})

            this.toast('Berhasil diperbarui');
            this.form.config.view = false;
          }).catch( err => {
            this.onError(err);
            this.form.isSubmit = false;
          });
        }
      },

      _delete(id){
        this.confirm.id = id
        this.confirm.title = 'Yakin ingin menghapus data tim ini?'
        this.confirm.action = () => {
          this.axios.delete('tim/'+id).then( () => {
            this.toast('Berhasil dihapus');
            this._get({silent: true})
            this.confirm.id = null
          }).catch( err => {
            this.onError(err);
            this.confirm.isSubmit = false
          });

        }
      },

      _pagePrev(){
        if(this.paginate.currentPage > 1){
          this.paginate.currentPage--
          this._get();
        }
      },

      _pageNext(){
        if(this.paginate.to % this.paginate.perPage == 0){
          this.paginate.currentPage++
          this._get();
        }
      },

      _pageChange(page){
        this.paginate.currentPage = page;
        this._get();
      },

      _search(keyword){
        this.dataFilter.keyword = keyword
        this._get()
      },

      _export(){
        this.isExportRequest = true;
        this.axios.get('tim', {
          params: {
            keyword: this.dataFilter.keyword,
          }
        }).then(res => {
          let data = res.data.data;

          let dataExcel = [];
          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            dataExcel.push({
              'Id': item.id,
              'Perusahaan': item.kode_perusahaan,
              'Depo': item.nama_depo,
              'Tim': item.nama_tim,
              'Supervisor': item.nama_supervisor,
              'Koordinator': item.nama_koordinator,
              'Tipe': item.tipe,
              'Min. Order SKU': item.min_order_sku,
              'Min. Order Value': item.min_order_value,
              'Status': item.status,
            });
          }

          this.createExcel({
            data: dataExcel,
            filename: 'tim-'+this.dateTime('ymd'),
          });

          this.isExportRequest = false;
        }).catch( err => {
          this.isExportRequest = false;
          this.onError(err);
        });
      }
  },

  mounted(){
    this.auth = JSON.parse(localStorage.user)
    this._get()
  }

};
</script>

<style lang="scss" scoped>
  hr{
    margin: 0 !important
  }
</style>
